import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import EvaluationTermUpdateRequest from "../form/request/EvaluationTermUpdateRequest";

const API_PREFIX = "/evaluationTerm";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async params => {
  const response = await post(`${API_PREFIX}/update`, new EvaluationTermUpdateRequest(params), authHeader());
  console.log("response", response);
  return response.data;
};
